import {RouterModule, Routes} from "@angular/router";
import {LoginComponent} from "./authentication/component/login/login.component";
import {HomeModule} from "./home/home.module";
import {AuthenticationGuard} from "./authentication/guard/authentication.guard";


function webpackSucks() {
    return HomeModule
}

const routes: Routes = [

    {
        path: "auth/login",
        component: LoginComponent,
    },
    {
        path: "",
        loadChildren: webpackSucks,
        canActivate: [AuthenticationGuard],
    },
];

export const routing = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/app.routing.ts